import React, { useEffect } from 'react';
import ScreenLoader from '@/components/ScreenLoader';
import { urlQuery, setUrlPath, showMessage } from '@/lib';
import dayjs from 'dayjs';
import { request } from '@/lib/axios';
import { useStore } from '@/store';
import Header from './Header';
import Footer from './Footer';
import lang from '@/lib/lng';
import config from '@/config';

const lng: { [key: string]: string } = lang[config?.lng];

type Props = {
	children: React.ReactNode;
	// Replace with the actual shape of userData
};

const MainLayout: React.FC<Props> = ({ children }) => {
	const { updateState } = useStore();

	useEffect(() => {
		const garena_token = urlQuery('garena_token') || urlQuery('access_token');
		// let clientLogged = localStorage.getItem('garena_token')
		const checkString =
			garena_token +
			dayjs().format('DD-MM-YYYY-mm') +
			import.meta.env.VITE_APP_PROJECT_NAME;

		// if(garena_token && checkString != clientLogged && garena_token.length >= 64) {
		if (garena_token) {
			request
				.get(
					`${window.location.origin}/connect/garena/callback?${garena_token.length > 70 ? 'garena_token' : 'access_token'
					}=${garena_token}&source_type=ingame`
				)
				.then(() => {
					updateState('loginSuccess', true);
					localStorage.setItem('garena_token', checkString);
					// if(response.status == 'success') {
					//   updateState('loginSuccess', true)
					//   localStorage.setItem('garena_token', checkString)
					//   // window.location.reload()
					// }
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
	  const verify = urlQuery('verify');
	  if (!verify) {
	    return;
	  }

	  const [provider, result] = verify.split('_'); // 'microsoft'|'google', 'ok'|'fail'
	  const providerLabel = provider === 'microsoft' ? 'Microsoft' : 'Google';

	  setUrlPath('/');

	  if (result === 'ok') {
	    showMessage(`Xác thực bằng ${providerLabel} thành công.`);
	  } else {
	    const reason = urlQuery('reason') ?? 'defaultError';
	    showMessage(lng[reason] ? lng[reason] : `${lng.defaultError} [${reason}]`);
	  }
	  // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<ScreenLoader />
			<Header />
			<section id="main-body">{children}</section>
			<Footer />
		</>
	);
};

export default MainLayout;
